export default {
    API_URL: 'https://adminzedsever.io/',
    PUSHER_KEY: 'ade9a16c954c4f590b9b',
    PAGE_TITLE: 'Business Help Center',
    LOGIN_URL: 'https://adminzedsever.io/',
    CLUSTER: 'mt1'
};